import React from 'react';
import { KeywordSearchPageQuery } from '../../../types';
import KeywordSearchPage from './results';

const KeyWordLandingPageWrapper = ({
  data,
}: {
  data: KeywordSearchPageQuery;
}) => {
  return <KeywordSearchPage data={data} />;
};

export default KeyWordLandingPageWrapper;
